import Grid from "@mui/material/Grid";
import React, {useMemo} from "react";
import {ElementDto} from "../../../../common/apis/element/ElementDto";
import {DateTimeFormatter} from "../../../../common/DateTimeFormatter";
import TextField from "../../../../components/fields/textfield/TextField";
import DataGridContainer from "../../../../components/grid/DataGridContainer";
import SectionHeader from "../../../../components/section/SectionHeader";
import {t} from "../../../../store/localization/TranslMessasge";
import ActivitiesGrid from "../activity/ActivitiesGrid";
import {ActivityGridColDefFactory} from "../activity/ActivityGridColDefFactory";
import {ElementTranslationKey} from "../elements/ElementTranslationKey";

export interface ElementHistoryPanelProps {
    element: ElementDto;
}

export default function ElementHistoryPanel(props: Readonly<ElementHistoryPanelProps>) {
    const {element} = props;

    const activityFilter = useMemo(() => ({
        entityIdent: element.identifier,
        entityRefIdent: element.identifier,
        validFrom: null,
        validThru: null
    }), [element.identifier]);

    const activityColumns = useMemo(() => {
        return ActivityGridColDefFactory.buildForElementDetail(element.identifier);
    }, [element.identifier]);

    return (
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextField
                            label={t(ElementTranslationKey.GRID_HEADER_DATE_CREATED)}
                            value={DateTimeFormatter.formatDateTime(element.created)}
                            readOnly={true}/>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                            label={t(ElementTranslationKey.GRID_HEADER_USER_CREATED)}
                            value={element.userCreated || ""}
                            readOnly={true}/>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                            label={t(ElementTranslationKey.GRID_HEADER_DATE_UPDATED)}
                            value={DateTimeFormatter.formatDateTime(element.updated)}
                            readOnly={true}/>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                            id="item-detail-basic-panel-userUpdated"
                            label={t(ElementTranslationKey.GRID_HEADER_USER_UPDATED)}
                            value={element.userUpdated || ""}
                            readOnly={true}/>
                </Grid>

                <Grid item xs={12}>
                    <SectionHeader title={t(ElementTranslationKey.ACTIVITIES)}/>
                </Grid>
                <Grid item xs={12} marginBottom={2}>
                    <DataGridContainer height={"480px"}>
                        <ActivitiesGrid
                                columns={activityColumns}
                                filter={activityFilter}/>
                    </DataGridContainer>
                </Grid>
            </Grid>
    );
}